import React, {useEffect, useState} from 'react'
import {BASE_URL} from '../utils/commonUrl';
import Layout from '../components/Layout'
import axios from 'axios';
import {useDispatch, useSelector} from 'react-redux'
import RoleCompetencyRcaForm from "./forms/RoleCompetencyRcaForm";
import {Button} from "primereact/button";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {fetchRoleCompetencyRca} from "../redux/features/RoleCompetencyRca.feature";
import {fetchUserRoleIndicator} from "../redux/features/competencyTitleIndicator.feature";
import { textAlign } from '@mui/system';
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {InputText} from "primereact/inputtext";

const RoleCompetencyRca = () => {    
    const dispatch = useDispatch();
    const state = useSelector((state => state["roleCompetencyRca"]))
    const [modal, setModal] = useState(false)
    const [start, setFirst] = useState(0);
    const [activeCompetencyTitleNames, setactiveCompetencyTitleNames] = useState([]);// DropDown
    const [activeUserRoleNames, setactiveUserRoleNames] = useState([]);// DropDown
    const [isLoading, setIsLoading] = useState(false);
	
    const [roleCompetencyRcaItem, setRoleCompetencyRcaItem] = useState({
					roleCompetencyRCAID: 0,
                    competencyID:0,  
                    userRoleID:0,                  
					weight: 0,
					rca:0,
                    active: true,
    })

    useEffect(() => {
        dispatch(fetchRoleCompetencyRca())
        dispatch(fetchUserRoleIndicator())
        UserRoleActiveNames()
        RoleCompetencyRcaActiveNames()
        initFilters1();        
    }, [])

    const RoleCompetencyRcaActiveNames = async () => {
        try {
            const url = BASE_URL + '/api/competency/GetActiveList'
            const response = await axios.get(url)
            if (response.status === 200) {
                const optionList = [{value: '-1', label: '--Please Select Competency--'}];
                response.data.map(val => optionList.push({value: val.competencyID, label: val.competencyName}))

                setactiveCompetencyTitleNames(optionList)
            }

        } catch (e) {
            console.log(e)
        }

    }

    const UserRoleActiveNames = async () => {
        try {
            const url = BASE_URL + '/api/userRole/GetActiveList'
            const response = await axios.get(url)
            if (response.status === 200) {
                const optionList = [{value: '-1', label: '--Please Select Role--'}];
                response.data.map(val => optionList.push({value: val.userRoleID, label: val.roleName}))

                setactiveUserRoleNames(optionList)
            }

        } catch (e) {
            console.log(e)
        }

    }

    const onSubmit = async data => {
        console.log(data);
        try {
            setIsLoading(true)
            const url = BASE_URL + "/api/roleCompetencyRca";
            const response = await axios.post(url, data);
            setIsLoading(false)
            if (response.status === 200) {
                dispatch(fetchRoleCompetencyRca())
                setRoleCompetencyRcaItem({
                    roleCompetencyRCAID: 0,
                    competencyID:0,  
                    userRoleID:0,                  
					weight: 0,
					rca:0,
                    active: true,
                })
                setModal(!modal)
            }
        } catch (e) {
            console.log(e)
            setIsLoading(false)
        }


    }

    const onHide = () => {
        setModal(!modal)
        setRoleCompetencyRcaItem({
            roleCompetencyRCAID: 0,
            competencyID:0,  
            userRoleID:0,                  
            weight: 0,
            rca:0,
            active: true,
        })
    }
	
    const editGridData = data => {
        console.log(data);
        setRoleCompetencyRcaItem({
            roleCompetencyRCAID: data.roleCompetencyRCAID,
            competencyID:data.competencyID,  
            userRoleID:data.userRoleID,                  
            weight: data.weight,
            rca:data.rca,
            active: true,
        });
        setModal(!modal);
    }

    const deleteGridData = data => {
        //setDeleteassestmentTitleIndicatorItem({quarterName:data.quarterName,quarterId:data.quarterID})
        //setDeleteProductDialog(true)
    }


    //filter begin

    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');

    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;
        let _filters1 = {...filters1};
        _filters1['global'].value = value;
        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }



    const initFilters1 = () => {
        setFilters1({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'competencyID': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            //'competencyTitle.competencyTitleName': {
            //    operator: FilterOperator.AND,
            //    constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            //},
            'userRoleID': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'weight': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'rca': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            
            'active': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
        });
        setGlobalFilterValue1('');
    }

    const clearFilter1 = () => {
        initFilters1();
    }


    //filter end



    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <Button icon="pi pi-pencil" className="p-button-rounded p-button-success mr-2"
                        onClick={() => editGridData(rowData)}/>
                &nbsp;   <Button icon="pi pi-trash" className="p-button-rounded p-button-warning"
                                 onClick={() => deleteGridData(rowData)}/>
            </>
        );
    }

    const header = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined" onClick={clearFilter1}/>
                    <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Keyword Search"/>
                </span>
                </div>
                <button type='button' onClick={() => setModal(!modal)} className='btn btn-primary'>Add Competency RCA
                </button>
            </div>
        </div>
    );

    const footer =`In total there are ${state.rolecompetencyrca ? state.rolecompetencyrca.length : 0} Role Competency RCA.`;

    const _isActiveColumn = (rowData) => {
        return <div>{rowData.active ? <>Active</> : <>Inactive</>}</div>
    }

    const Table = (
        <DataTable value={state.rolecompetencyrca}
                   showGridlines
                   dataKey="roleCompetencyRCAID" filters={filters1} filterDisplay="menu"
                   globalFilterFields={['roleName', 'competencyName','weight','rca','active']}
                   header={header} footer={footer} paginator rows={7} first={start}
                   paginatorTemplate="RowsPerPageDropdown PageLinks FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
            <Column field="roleCompetencyRCAID" header="roleCompetencyRCAID" hidden={true}/>            
            <Column field="userRoleID" header="Role" hidden={true}/>
            <Column field="roleName" header="Role" />
            <Column field="competencyID" header="Competency" hidden={true}/>
            <Column field="competencyName" header="Competency"/>                        
            <Column field='weight' header="Weight"/>
            <Column field='rca' header="RCA"/>
            <Column field='active' header="Active" body={_isActiveColumn}/>
            <Column body={actionBodyTemplate} header="Action" exportable={false} style={{minWidth: '4rem', textAlign:"center"}}/>
        </DataTable>
    )
	
    return (
        <Layout>
            <RoleCompetencyRcaForm
                isLoading={isLoading}                
                setactiveCompetencyTitleNames={activeCompetencyTitleNames}
                setactiveUserRoleNames={activeUserRoleNames}
                roleCompetencyRCAID={roleCompetencyRcaItem.roleCompetencyRCAID} 
                competencyID={roleCompetencyRcaItem.competencyID}  
                userRoleID={roleCompetencyRcaItem.userRoleID}                                                  
                weight={roleCompetencyRcaItem.weight}
                rca={roleCompetencyRcaItem.rca}
                active={roleCompetencyRcaItem.active}
                modal={modal}
                onSubmit={onSubmit}
                onHide={onHide}/>
            {Table}
        </Layout>
    )
}

export default RoleCompetencyRca